import React, { useMemo } from 'react'

import {
  LogoFacebookComponent,
  LogoInstagramComponent,
  LogoLinkedInComponent,
} from 'Assets/Svg'

import { SOCIAL_LINKS } from 'Constants/ContactData'
import { SocialLinkKindId } from 'Constants/Ids'

import { Container } from './styles'

type Props = { kind: SocialLinkKindId; secondary?: boolean }

function SocialLink({ kind, secondary }: Props) {
  const { href, icon, size } = useMemo(() => {
    switch (kind) {
      case SocialLinkKindId.Facebook:
        return {
          href: SOCIAL_LINKS[SocialLinkKindId.Facebook],
          icon: LogoFacebookComponent(),
          size: 18,
        }
      case SocialLinkKindId.Instagram:
        return {
          href: SOCIAL_LINKS[SocialLinkKindId.Instagram],
          icon: LogoInstagramComponent(),
          size: 20,
        }
      case SocialLinkKindId.LinkedIn:
        return {
          href: SOCIAL_LINKS[SocialLinkKindId.LinkedIn],
          icon: LogoLinkedInComponent(),
          size: 16,
        }
      default:
        return { href: undefined, icon: undefined, size: undefined }
    }
  }, [kind])

  if (!href || !icon) return null

  return (
    <Container
      href={href}
      rel="noopener noreferrer"
      secondary={secondary}
      size={size}
      target="_blank"
    >
      {icon}
    </Container>
  )
}

export default SocialLink
